import { render, staticRenderFns } from "./CouponEdit.vue?vue&type=template&id=2f766b90&scoped=true&"
import script from "./CouponEdit.vue?vue&type=script&lang=js&"
export * from "./CouponEdit.vue?vue&type=script&lang=js&"
import style0 from "./CouponEdit.vue?vue&type=style&index=0&id=2f766b90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f766b90",
  null
  
)

export default component.exports